exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":root {\n\n  /*colors named by https://www.color-blindness.com/color-name-hue/*/\n\n  /*shadow*/\n\n  /*z-index*/\n\n  /*transition*/\n\n  /*radius*/\n\n  /*chat*/\n}\n\n._3JZYMgZ {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n", ""]);
// Exports
exports.locals = {
	"Messenger": "_3JZYMgZ"
};